import { render, staticRenderFns } from "./AuditHistoryChart.vue?vue&type=template&id=212008a2"
import script from "./AuditHistoryChart.vue?vue&type=script&lang=ts"
export * from "./AuditHistoryChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports